import { ChangeDetectionStrategy, Component, inject } from "@angular/core";

import {
  PortSubscriptionDetailsGQL,
  PortSubscriptionDetailsQuery,
} from "../../../../apis/networkdashboard/graphql/graphql";
import { SubscriptionPageComponent } from "../../../../components/subscription-detail/subscription-page/subscription-page";
import { ServicePortSubscriptionDetails } from "../../types";
import { GenericSubscription } from "../generic-subscription";
import { PortSubscriptionViewComponent } from "./port-subscription-view";

@Component({
  selector: "port-subscription",
  templateUrl: "port-subscription.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [PortSubscriptionViewComponent, SubscriptionPageComponent],
})
export class PortSubscriptionComponent extends GenericSubscription<
  PortSubscriptionDetailsQuery,
  ServicePortSubscriptionDetails
> {
  protected query = inject(PortSubscriptionDetailsGQL);

  protected onQuerySuccess(data: PortSubscriptionDetailsQuery): ServicePortSubscriptionDetails {
    return data.servicePortDetails;
  }
}
